function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &.mui-dt-root {\n    ",
        ";\n    ",
        ";\n  }\n\n  .mui-dt-input-root {\n    background-color: var(--dcm-checkout-input-bg, #fcfdfe) !important;\n    border: 1px solid var(--dcm-checkout-input-border-color, #caced4);\n    &.mui-dt-input-error {\n      border: 1px solid #e25241;\n    }\n\n    &.iframe-input {\n      height: 53px;\n      @media only screen and (min-width: 768px) {\n        height: 45px;\n      }\n\n      iframe {\n        height: 16px !important;\n        position: relative;\n        transform: translate3d(19px, 5px, 0);\n        transition: transform 0s, opacity 0.3s;\n        @media only screen and (min-width: 768px) {\n          transform: translate3d(17px, 5px, 0);\n        }\n      }\n      .mui-dt-input-input {\n        display: none;\n      }\n    }\n    &.iframe-input.unfocused {\n      iframe {\n        /* HACK: Some versions of Chrome seem to disable iframe mouse events when set to opacity: 0 */\n        opacity: 0.00000000001;\n        transition: transform 0s 0.1s, opacity 0.1s;\n        transform: translate3d(0, 0, 0);\n        height: 100% !important;\n      }\n    }\n  }\n\n  .mui-dt-input-input {\n    font-size: 16px;\n    padding: 22px 5px 6px 20px;\n    caret-color: #6fa48e;\n    color: var(--dcm-checkout-text-color, #5d666d);\n    height: 23px;\n\n    @media only screen and (min-width: 768px) {\n      font-size: 13px;\n      height: 19px;\n      padding: 19px 5px 5px 18px;\n    }\n\n    &.--dollar-cleave:not(.--has-value) {\n      color: transparent;\n\n      &:focus {\n        color: var(--dcm-checkout-text-color, #5d666d);\n      }\n    }\n\n    &.credit-card-cleave.visa {\n      position: relative;\n      &:before {\n        content: ' ';\n        height: 10px;\n        width: 30px;\n        background-color: red;\n        position: absolute;\n        top: 50%;\n        right: 20px;\n        transform: translate(-50%, -50%);\n      }\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.75;\n    }\n  }\n\n  .mui-dt-label-root {\n    color: var(--dcm-checkout-text-muted-color, #858788);\n    font-size: 16px;\n    transform: translate(20px, 19px) scale(1);\n    transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,\n      font-size 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    &.mui-dt-label-shrink {\n      // transform: translate(20px, 10px) scale(0.8);\n      transform: translate(20px, 10px);\n      font-size: 10px;\n\n      @media only screen and (min-width: 768px) {\n        // transform: translate(18px, 8px) scale(0.8);\n        transform: translate(18px, 8px);\n        --webkit-transform: translate(18px, 8px);\n        font-size: 10px;\n      }\n    }\n    &.mui-dt-label-error {\n      color: #e25241 !important;\n    }\n    &.mui-dt-label-focused {\n      color: var(--dcm-checkout-text-muted-color, #858788);\n    }\n\n    @media only screen and (min-width: 768px) {\n      font-size: 13px;\n      transform: translate(18px, 17px) scale(1);\n    }\n  }\n  .mui-dt-input-underline:before {\n    display: none;\n  }\n  .mui-dt-input-underline:after {\n    transform: scale(0) !important; // remove underline highlight\n  }\n\n  .MuiFormLabel-asterisk {\n    display: none;\n  }\n  .focus-visible {\n    box-shadow: none !important;\n  }\n  .Mui-focused {\n    border-color: ",
        " !important;\n    & > input,\n    textarea {\n      box-shadow: 0px 1px 5px ",
        " !important;\n    }\n    background-color: var(--dcm-checkout-input-bg, ",
        ") !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n\n  div:first-of-type {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  position: absolute;\n  top: 18px;\n  right: 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #4597e0;\n  cursor: pointer;\n  @media only screen and (min-width: 768px) {\n    top: 17px;\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  p {\n    color: #a3afba;\n    font-size: 13px;\n    font-weight: bold;\n    line-height: 15px;\n    padding: 2px 6px 0 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  ",
        ";\n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translate(-50%, -50%);\n    background-repeat: no-repeat;\n    height: 28px;\n    width: 28px;\n    background-image: url(/icons/default-card.svg);\n    background-size: contain;\n    @media ",
        " {\n      right: 2px;\n    }\n  }\n  &.visa {\n    &::after {\n      background-image: url(/icons/visa.svg);\n    }\n  }\n  &.mastercard,\n  &.master.card {\n    &::after {\n      background-image: url(/icons/mastercard.svg);\n    }\n  }\n  &.discover {\n    &::after {\n      background-image: url(/icons/discover.svg);\n    }\n  }\n  &.amex,\n  &.american.express {\n    &::after {\n      background-image: url(/icons/amex.svg);\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translate(0, -50%);\n  z-index: 2; /* position above ui labels */\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import _ from 'lodash';
import { Box } from '@dutchie/common/components/rebass-compat';
import styled from 'styled-components';
import { space, width } from 'styled-system';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MaskedInput from 'react-number-format';
import Cleave from 'cleave.js/react';
import { Tooltip } from 'shared/components';
import { mediaQueries } from 'shared/styles';
export var DefaultInput = function(_param) {
    var label = _param.label, onChange = _param.onChange, value = _param.value, error = _param.error, errorMessage = _param.errorMessage, _param_onValueAfterError = _param.onValueAfterError, onValueAfterError = _param_onValueAfterError === void 0 ? _.noop : _param_onValueAfterError, props = _object_without_properties(_param, [
        "label",
        "onChange",
        "value",
        "error",
        "errorMessage",
        "onValueAfterError"
    ]);
    return /*#__PURE__*/ _jsx(StyledTextInputWithLabel, _object_spread({
        variant: "filled",
        error: !!error,
        label: error && errorMessage ? errorMessage : label,
        value: value,
        onChange: function(e) {
            if (onChange) {
                onChange(e);
            }
            if (error) {
                onValueAfterError(e);
            }
        }
    }, props));
};
export var FormattedInputWithButton = function(_param) {
    var buttonText = _param.buttonText, onSubmit = _param.onSubmit, _param_Input = _param.Input, Input = _param_Input === void 0 ? DefaultInput : _param_Input, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, props = _object_without_properties(_param, [
        "buttonText",
        "onSubmit",
        "Input",
        "disabled"
    ]);
    return /*#__PURE__*/ _jsxs(InputWithButtonContainer, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx(Input, _object_spread_props(_object_spread({}, props), {
                mt: "0",
                mb: "0",
                m: "0",
                pt: "0",
                pb: "0",
                p: "0"
            })),
            ' ',
            /*#__PURE__*/ _jsx(InputButton, {
                onClick: onSubmit,
                disabled: disabled,
                children: buttonText || 'Save'
            })
        ]
    }));
};
export var DateInput = function(props) {
    return /*#__PURE__*/ _jsx(MaskedInput, _object_spread({
        displayType: "input",
        customInput: DefaultInput,
        format: "##/##/####",
        placeholder: "mm/dd/yyyy",
        mask: [
            'm',
            'm',
            'd',
            'd',
            'y',
            'y',
            'y',
            'y'
        ]
    }, props));
};
export var ExpirationDateInput = function(props) {
    return /*#__PURE__*/ _jsx(MaskedInput, _object_spread({
        displayType: "input",
        customInput: DefaultInput,
        format: "##/####",
        placeholder: "mm/yyyy",
        mask: [
            'm',
            'm',
            'y',
            'y',
            'y',
            'y'
        ]
    }, props));
};
export var CvvInput = function(props) {
    var ctnWidth = props.width;
    return /*#__PURE__*/ _jsxs(CvvContainer, {
        width: ctnWidth,
        children: [
            /*#__PURE__*/ _jsx(MaskedInput, _object_spread({
                displayType: "input",
                customInput: DefaultInput,
                format: "####"
            }, props)),
            /*#__PURE__*/ _jsx(TooltipContainer, {
                children: /*#__PURE__*/ _jsx(Tooltip, {
                    tooltipCopy: "The 3 or 4 digit number commonly found on the front or back of your credit card.",
                    grey: true,
                    width: "257px",
                    left: "auto",
                    right: "-42px",
                    bottom: "25px",
                    arrowRight: "42px"
                })
            })
        ]
    });
};
export var PhoneNumberInput = function(props) {
    return /*#__PURE__*/ _jsx(MaskedInput, _object_spread({
        displayType: "input",
        customInput: DefaultInput,
        format: "(###) ###-####",
        placeholder: "(___) ___-____",
        mask: "_",
        type: "tel"
    }, props));
};
var CreditCardCleaveInput = function(_param) {
    var _param_onCreditCardTypeChanged = _param.onCreditCardTypeChanged, onCreditCardTypeChanged = _param_onCreditCardTypeChanged === void 0 ? _.noop : _param_onCreditCardTypeChanged, _inputRef = _param._inputRef, props = _object_without_properties(_param, [
        "onCreditCardTypeChanged",
        "_inputRef"
    ]);
    return /*#__PURE__*/ _jsx(Cleave, _object_spread_props(_object_spread({}, props), {
        options: {
            creditCard: true,
            onCreditCardTypeChanged: onCreditCardTypeChanged
        }
    }));
};
export var CreditCardInput = function(_param) {
    var cardTypeChanged = function cardTypeChanged(type) {
        setCardType(type);
        onCreditCardTypeChanged(type);
    };
    var _param_onCreditCardTypeChanged = _param.onCreditCardTypeChanged, onCreditCardTypeChanged = _param_onCreditCardTypeChanged === void 0 ? _.noop : _param_onCreditCardTypeChanged, mt = _param.mt, mb = _param.mb, m = _param.m, pt = _param.pt, pb = _param.pb, p = _param.p, cardTypeFromProps = _param.cardType, props = _object_without_properties(_param, [
        "onCreditCardTypeChanged",
        "mt",
        "mb",
        "m",
        "pt",
        "pb",
        "p",
        "cardType"
    ]);
    var _useState = _sliced_to_array(useState(''), 2), cardType = _useState[0], setCardType = _useState[1];
    var InputProps = {
        inputComponent: CreditCardCleaveInput,
        inputProps: {
            onCreditCardTypeChanged: cardTypeChanged
        }
    };
    return /*#__PURE__*/ _jsx(CreditCardContainer, {
        className: "".concat(cardTypeFromProps, " ").concat(cardType),
        mt: mt,
        mb: mb,
        m: m,
        pt: pt,
        pb: pb,
        p: p,
        children: /*#__PURE__*/ _jsx(DefaultInput, _object_spread({
            InputProps: InputProps
        }, props))
    });
};
var DollarCleaveInput = function(_param) {
    var className = _param.className, inputRef = _param.inputRef, value = _param.value, props = _object_without_properties(_param, [
        "className",
        "inputRef",
        "value"
    ]);
    var _String;
    return /*#__PURE__*/ _jsx(Cleave, _object_spread_props(_object_spread({}, props), {
        value: value,
        className: "".concat(className, " --dollar-cleave ").concat(value && ((_String = String(value)) === null || _String === void 0 ? void 0 : _String.length) > 0 && '--has-value'),
        htmlRef: function(ref) {
            return inputRef(ref);
        },
        options: {
            prefix: '$',
            numeral: true,
            numeralPositiveOnly: true,
            numeralThousandsGroupStyle: 'thousand'
        }
    }));
};
export var DollarInput = function(_param) {
    var hasCurrencyLabel = _param.hasCurrencyLabel, _param_currency = _param.currency, currency = _param_currency === void 0 ? 'USD' : _param_currency, props = _object_without_properties(_param, [
        "hasCurrencyLabel",
        "currency"
    ]);
    var InputProps = {
        inputComponent: DollarCleaveInput
    };
    if (hasCurrencyLabel) {
        InputProps.endAdornment = /*#__PURE__*/ _jsx(EndAdornment, {
            position: "end",
            children: currency
        });
    }
    return /*#__PURE__*/ _jsx(DefaultInput, _object_spread({
        InputProps: InputProps
    }, props));
};
var StyledTextInputWithLabel = styled(function(_param) {
    var _param_InputProps = _param.InputProps, InputProps = _param_InputProps === void 0 ? {} : _param_InputProps, _param_InputLabelProps = _param.InputLabelProps, InputLabelProps = _param_InputLabelProps === void 0 ? {} : _param_InputLabelProps, containerClassName = _param.containerClassName, props = _object_without_properties(_param, [
        "InputProps",
        "InputLabelProps",
        "containerClassName"
    ]);
    return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, props), {
        classes: {
            root: 'mui-dt-root'
        },
        InputProps: _object_spread_props(_object_spread({}, InputProps), {
            classes: {
                root: "mui-dt-input-root ".concat(containerClassName || ''),
                input: 'mui-dt-input-input',
                error: 'mui-dt-input-error',
                underline: 'mui-dt-input-underline'
            }
        }),
        InputLabelProps: _object_spread_props(_object_spread({}, InputLabelProps), {
            classes: {
                root: 'mui-dt-label-root',
                focused: 'mui-dt-label-focused',
                error: 'mui-dt-label-error',
                shrink: 'mui-dt-label-shrink'
            }
        })
    }));
})(_templateObject(), space, width, function(param) {
    var theme = param.theme;
    var _theme_colors;
    var _theme_colors_blue_;
    return (_theme_colors_blue_ = theme === null || theme === void 0 ? void 0 : (_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.blue[55]) !== null && _theme_colors_blue_ !== void 0 ? _theme_colors_blue_ : '#4c94d7';
}, function(param) {
    var theme = param.theme;
    var _theme_colors;
    var _theme_colors_blueShadow;
    return (_theme_colors_blueShadow = theme === null || theme === void 0 ? void 0 : (_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.blueShadow) !== null && _theme_colors_blueShadow !== void 0 ? _theme_colors_blueShadow : 'rgba(11, 153, 230, 0.4)';
}, function(param) {
    var theme = param.theme;
    var _theme_colors;
    var _theme_colors_white;
    return (_theme_colors_white = theme === null || theme === void 0 ? void 0 : (_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.white) !== null && _theme_colors_white !== void 0 ? _theme_colors_white : '#fff';
});
var InputWithButtonContainer = styled(Box)(_templateObject1());
var InputButton = styled.button(_templateObject2());
var EndAdornment = styled(InputAdornment)(_templateObject3());
var CreditCardContainer = styled.div(_templateObject4(), space, mediaQueries.largePhone);
var CvvContainer = styled.div(_templateObject5(), width);
var TooltipContainer = styled.div(_templateObject6());
